app.views.announcement = app.views.base.extend({
  childEvents: {
    'click [data-announce-close]': 'onCloseAnnouncement'
  },
  settings: {
    cookieId: 'PRA.Announcement',
    dialogUrl: '/announcement/dialog',
    type: {
      banner: 'banner',
      popup: 'popup'
    },
    status: {
      info: 'info',
      warning: 'warning',
      error: 'error'
    }
  },
  attr: {
    id: 'data-announceid',
    announcement: 'data-announce'
  },
  classes: {
    bodyModifier: 'announce--visible',
    hidden: 'announce--hidden'
  },
  /**
   * Initialise Registration View Listener
   * @public
   * @constructor
   */

  init: function init(type, status) {
    switch (type) {
      case this.settings.type.banner:
        $('body').addClass(this.classes.bodyModifier);
        break;
      case this.settings.type.popup:
        this.setAnnouncementPopupType(status);
        break;
      default:
        console.error('Unknown announcement type provided.');
    }
  },
  /**
   * On Close Announcement
   * Fires when te user clicks the close or acceptance button.
   * @public
   * @param {event} e : the submit button event.
   */

  onCloseAnnouncement: function onCloseAnnouncement(e) {
    var announcement = $(e.currentTarget).parents('[' + this.attr.announcement + ']');
    var id = announcement.attr(this.attr.id);
    if ($.magnificPopup.instance.isOpen) {
      $.magnificPopup.instance.close();
    } else {
      announcement.addClass(this.classes.hidden);
      $('body').removeClass(this.classes.bodyModifier);
    }
    this.setAnnouncementCookie(id);
  },
  /**
   * Set Announcement Pop Type
   * Determines if the popup announcement should show as a popup or a dialog.
   * @public
   * @param {param} status : the status of the announcement
   */

  setAnnouncementPopupType: function setAnnouncementPopupType(status) {
    switch (status) {
      case this.settings.status.info:
      case this.settings.status.warning:
        break;
      // Nothing to do.
      case this.settings.status.error:
        app.helpers.openModal(this.settings.dialogUrl, 'ajax');
        break;
      default:
        console.error('Unknown announcement status provided.');
    }
  },
  /**
   * Set Announcement Cookie
   * Sets a session cookie if the user closes the announcement.
   * @public
   * @param {param} cookie : the identifier of the cookie.
   */

  setAnnouncementCookie: function setAnnouncementCookie(cookie) {
    var id = this.settings.cookieId;
    var announcementCookie = id + '=' + cookie.trim();
    document.cookie = announcementCookie;
    return null;
  }
});